var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"list-group"},_vm._l((_vm.value),function(war,index){return _c('li',{key:index,staticClass:"list-group-item bg-light-secondary"},[_vm._v(_vm._s(war))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }